import React from 'react';
import PropTypes from 'prop-types';
import { hasRoundel } from '../../components/PromoIconography/promotionUtilities';
import BrandIcon from './BrandIcon';
import MessageIcon from './MessageIcon';
import MyWaitroseIcon from './MyWaitroseIcon';
import PromoRoundel from './PromoRoundel';
import styles from './PromoIconography.scss';
const isSupercharged = icons => { var _a, _b; return ((_b = (_a = icons === null || icons === void 0 ? void 0 : icons.myWaitroseIcon) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.supercharged) || false; };
const PromoIconography = ({ hideMessage, icons }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const brandIconProps = Object.assign(Object.assign({}, ((icons === null || icons === void 0 ? void 0 : icons.brandIcon) || {})), { adjust: hideMessage });
    const messageIconProps = {
        display: (_a = icons === null || icons === void 0 ? void 0 : icons.messageIcon) === null || _a === void 0 ? void 0 : _a.display,
        message: (_c = (_b = icons === null || icons === void 0 ? void 0 : icons.messageIcon) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message,
        theme: (_e = (_d = icons === null || icons === void 0 ? void 0 : icons.messageIcon) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.theme,
    };
    const myWaitroseProps = {
        additionalReduction: (_g = (_f = icons === null || icons === void 0 ? void 0 : icons.myWaitroseIcon) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.additionalReduction,
        display: (_h = icons === null || icons === void 0 ? void 0 : icons.myWaitroseIcon) === null || _h === void 0 ? void 0 : _h.display,
        roundel: hasRoundel(icons),
        supercharged: isSupercharged(icons),
    };
    const roundelProps = {
        display: (_j = icons === null || icons === void 0 ? void 0 : icons.offerRoundel) === null || _j === void 0 ? void 0 : _j.display,
        image: (_k = icons === null || icons === void 0 ? void 0 : icons.offerRoundel) === null || _k === void 0 ? void 0 : _k.image,
        supercharged: isSupercharged(icons),
    };
    return (React.createElement("div", { className: styles.wrapper },
        !hideMessage && React.createElement(MessageIcon, Object.assign({}, messageIconProps)),
        React.createElement(BrandIcon, Object.assign({}, brandIconProps)),
        React.createElement(MyWaitroseIcon, Object.assign({}, myWaitroseProps)),
        React.createElement(PromoRoundel, Object.assign({}, roundelProps))));
};
PromoIconography.defaultProps = {
    hideMessage: false,
    icons: {},
};
PromoIconography.propTypes = {
    hideMessage: PropTypes.bool,
    icons: PropTypes.object,
};
export default PromoIconography;
//# sourceMappingURL=index.js.map